import { IAppState } from '../../../AppModulesWrapper';

import { EOfferDraftStatus } from '../../types/reducers/draft';

export function selectIsSaveDraftPending(state: IAppState): boolean {
  const {
    draft: { status },
  } = state.servicePickerWidget;

  return status === EOfferDraftStatus.pending;
}
